import {ERROR, START, SUCCESS} from "../../../../constants/action-postfix";
import {GRADUATES_HEO_REQUEST} from "../graduatesHEOReducer";


const initialState = false;

export const loaderReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${GRADUATES_HEO_REQUEST}${START}`:
            return true;
        case `${GRADUATES_HEO_REQUEST}${SUCCESS}`:
            return false;
        case `${GRADUATES_HEO_REQUEST}${ERROR}`:
            return false;
        default:
            return state;
    }
};